export const SET_MANAGEMENT_TAB = "SET_MANAGEMENT_TAB";
export const CLEAR_MANAGEMENT_TAB = "CLEAR_MANAGEMENT_TAB";